import React, { useEffect, useState, useMemo } from "react";
import { useFirebaseStorage } from "utils/hooks/useFirebaseStorage";
import {
	convertQueueEdit,
	getRecordDetail,
	postUploadQuestion,
	getSchedulePaginationList,
	putDeleteRecord,
	putDeleteFile,
	getQuerySeparateRecordSelection,
	putEditCheck,
	getQuestionList,
	getErrorExportFile,
	deleteRecordFile,
	postReSeparateRecord,
	postBatchErrorExportFile,
} from "api/convert";
import { getQuestionHtml } from "api/bank";
import { v4 as uuidv4 } from "uuid";
import { useMachine } from "@xstate/react";
import { fetchMachine, FetchEventType } from "machines/fetchMachine";
import {
	getSchoolYear,
	setSelectOptions,
	getStartDay,
	getEndDay,
	filterEmptyObject,
	sliceTableData,
} from "utils/common";
import { Table, Pagination, Button, Icon, Upload, Select, Loading } from "common-components";
import { Modal, Tabs, Image, DatePicker, Checkbox } from "antd";
import { getTime, format } from "date-fns";
import { BoxEditSolid } from "@onedesign/icon";
import openNotificationWithIcon from "utils/hooks/useNotification";
import { getSpecificationProductFilter } from "api/specification";
import { Breadcrumb, FileCheck } from "components";
import queryString from "query-string";
import { useBoolean } from "ahooks";
import {
	UiQuestionRevisePage,
	UiPopupContainer,
	UiButtons,
	UiQuesDetail,
	UiRuleModalContent,
	UiLoadingBox,
	UiLink,
	StyledModal,
} from "./QuestionRevisePage.style";
import { parse } from "query-string";
import { API_BATCH_QUEUE, defaultParamsList } from "constants/index";
import { useLocation, useHistory } from "react-router-dom";
import moment from "moment";
import { FetchStates } from "machines/fetchMachine";

const { RangePicker } = DatePicker;

const dateFormat = "YYYY-MM-DD";

const titleMapByProductType = (value) => {
	switch (value) {
		case String(API_BATCH_QUEUE.PRODUCT_TYPE.equationDojo):
			return "無限命題修改";
		case String(API_BATCH_QUEUE.PRODUCT_TYPE.livePreTest):
			return "Live試聽前測卷修改";
		case String(API_BATCH_QUEUE.PRODUCT_TYPE.mockExam):
			return "模擬考試題修改";
		case String(API_BATCH_QUEUE.PRODUCT_TYPE.validationQuestions):
			return "檢定試題修改";
		case String(API_BATCH_QUEUE.PRODUCT_TYPE.vocabularyTest):
			return "英文單字刷題試題修改";
		case String(API_BATCH_QUEUE.PRODUCT_TYPE.eduService):
			return "教務試題修改";
		case String(API_BATCH_QUEUE.PRODUCT_TYPE.englishListening):
			return "英聽試題入庫";
		default:
			return "一般試題修改";
	}
};

const filterTypeOptions = [
	{
		name: "顯示全部題目",
		value: null,
	},
	{
		name: "僅顯示成功",
		value: 0,
	},
	{
		name: "僅顯示失敗",
		value: 1,
	},
];

const finishedStatusOptions = [
	{
		name: "顯示全部作業狀況",
		value: null,
	},
	{
		name: "僅顯示完成作業",
		value: true,
	},
	{
		name: "僅顯示未完成作業",
		value: false,
	},
];

/**
 * 試題修改
 */
const { Header, Body, Row, Item } = Table;

const MODIFY = 1;
const showCodeList = ["CORE_ACCOMPLISHMENT", "PERFORMANCE", "LEARN_CONTENT", "KNOWLEDGE"];

export const QuestionRevisePage = () => {
	const location = useLocation();
	const history = useHistory();

	const productType = useMemo(() => parse(location.search).productType, [location.search]);
	const breadcrumbList = useMemo(
		() => [
			{
				oneClassIcon: <BoxEditSolid />,
				name: titleMapByProductType(productType),
				path: "/",
			},
		],
		[productType],
	);
	const [detailPopup, setDetailPopup] = useState({
		visible: false,
	});

	// 所有下拉選單的資料
	const [selectionData, setSelectionData] = useState({});

	const [isLoading, setIsLoading] = useState(false);

	const { upload } = useFirebaseStorage();

	const [uploadPopup, setUploadPopup] = useState(false);

	const [files, setFiles] = useState([]);

	const [detailPage, setDetailPage] = useState(1);

	const [pageState, setPageState] = useState({
		currentPage: 1,
		limit: 10,
	});
	const [bookTagPath, setBookTagPath] = useState("");
	const [bookTagIsListen, setBookTagIsListen] = useState(false);

	// 批次刪除檔案
	const [checkList, setCheckedList] = useState([]);

	const initUrlParams = queryString.parse(useLocation().search);
	const [urlParams, setUrlParams] = useState(initUrlParams);

	const [deletePopupState, setDeletePopupState] = useState(false);

	// 試題列表 Modal
	const [detailModalVisible, { toggle: setDetailModalToggle, setFalse: setDetailModalFalse }] = useBoolean(false);
	const [detailModalData, setDetailModalData] = useState({
		data: null,
		fileUID: null,
	});

	// 翻頁相關功能
	const [detailPageListState, setDetailListPage] = useState({
		currentPage: 1,
		limit: 100,
	});
	const [fileUID, setFileUID] = useState(null);

	const nowSchoolYear = getSchoolYear();
	const today = new Date();
	const before1Month = new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000);

	const [searchParams, setSearchParams] = useState({
		failType: null,
		year: nowSchoolYear + "",
		version: null,
		edu: null,
		subject: null,
		book: null,
		source: null,
		subSource: null,
		isChecked: null,
		fileName: "",
		userName: "",
		startDateTime: getStartDay(before1Month),
		EndDateTime: getEndDay(today),
	});

	const [stateGetSeparateRecord, sendGetSeparateRecord] = useMachine(fetchMachine, {
		services: {
			fetchData: async () => {
				setIsLoading(true);
				const {
					year,
					version,
					edu,
					subject,
					book,
					source,
					subSource,
					isChecked,
					failType,
					userName,
					fileName,
					startDateTime,
					EndDateTime,
				} = searchParams;

				const payload = {
					failType,
					productType: productType,
					pagenumber: pageState.currentPage,
					pagesize: pageState.limit,
					version,
					year,
					education: edu,
					subjectCode: subject,
					bookCode: book,
					sourceCode: source,
					subsourceCode: subSource,
					isChecked,
					userName,
					fileName,
					StartDateTime: startDateTime.toISOString(),
					EndDateTime: EndDateTime.toISOString(),
					queueType: MODIFY,
				};

				if (payload.failType === "all") delete payload.failType;
				const { data, isSuccess, message } = await getSchedulePaginationList(filterEmptyObject(payload));
				const { isFinished, totalcount, records } = data;
				setIsLoading(false);
				return {
					records,
					totalCount: totalcount,
					isSuccess,
					message,
					isFinished,
				};
			},
			deleteData: async (_c, event) => await putDeleteRecord(event.fileUID),
		},
	});

	const { records, totalCount } = stateGetSeparateRecord.context.result || {};

	useEffect(() => {
		fetchRecords();
	}, [pageState.currentPage, pageState.limit]);

	// 批次匯出錯誤檔案
	const [stateBatchExport, sendBatchExport] = useMachine(fetchMachine, {
		services: {
			fetchData: async (_c, event) => {
				const { data, isSuccess, message } = await postBatchErrorExportFile(event.payload);

				openNotificationWithIcon("success", "匯出中，請點左側匯出列表查看");

				return {
					isSuccess,
					message,
					data,
				};
			},
		},
	});

	const handleBatchExport = () => {
		const exportList = checkList.filter((item) => {
			const isWorkDone = records.find((dataItem) => dataItem.uid === item.uid)?.isChecked;

			return !isWorkDone;
		});

		if (exportList.length === 0) return;

		const payload = {
			fileUIDs: exportList.map((item) => item.uid),
		};

		sendBatchExport(FetchEventType.Fetch, { payload });
	};

	// 取得 匯出列表
	const [, sendGetQuerySeparateRecordSelection] = useMachine(fetchMachine, {
		services: {
			fetchData: async (_c, event) => {
				const { data, isSuccess, message } = await getQuerySeparateRecordSelection();
				const { bookMap, eduMap, eduSubject, eduVersion, sourceMap, subSourceMap, yearMap } = data;
				setSelectionData({ bookMap, eduMap, eduSubject, eduVersion, sourceMap, subSourceMap, yearMap });
				return {
					data,
					isSuccess,
					message,
				};
			},
		},
	});

	// 取得 題目詳情 資料
	const [stateRecordDetail, sendRecordDetail] = useMachine(fetchMachine, {
		services: {
			fetchData: async (_c, event) => {
				const { data } = await getRecordDetail(event.eduSubject, event.fileUID);
				return {
					detailList: data,
				};
			},
		},
	});

	const { detailList } = stateRecordDetail.context.result || {};

	const targetDetail = useMemo(() => {
		if (!detailList) return {};
		return detailList[detailPage - 1];
	}, [detailPage, detailList]);

	const targetSelectOptions = useMemo(() => {
		let result = [];
		if (Object.keys(targetDetail).length === 0 || !targetDetail.detailImage) return result;

		result =
			targetDetail?.detailImage.map((item) => ({
				name: item.name,
				value: item.path,
				isListen: false,
			})) || [];
		if (targetDetail.soundtracks) {
			const listenList = targetDetail.soundtracks.map((item) => ({
				name: item.name,
				value: item.path,
				isListen: true,
			}));
			result = result.concat(listenList);
		}
		return result;
	}, [targetDetail]);

	const toggleDetailVisible = (item) => {
		if (!detailPopup.visible) {
			setDetailPage(1);
			setBookTagPath("");
			setBookTagIsListen(false);
			const { eduSubject, uid } = item;
			sendRecordDetail(FetchEventType.Fetch, {
				eduSubject,
				fileUID: uid,
			});
			setDetailEduSubject(eduSubject);
		}
		setDetailPopup({
			...detailPopup,
			visible: !detailPopup.visible,
		});
	};

	const changeFileList = (value) => {
		setFiles(value);
	};
	const submitFiles = async () => {
		if (files.length === 0) return;
		setIsLoading(true);
		const filesArray = [];

		const params = () => {
			if (!productType) {
				return {
					...defaultParamsList[1],
					isRefesth: false,
					queueType: MODIFY,
					productType: productType ?? 1,
					ppt: true,
				};
			} else {
				return {
					...defaultParamsList[productType],
					isRefesth: false,
					queueType: MODIFY,
					productType: productType ?? 1,
					ppt: true,
				};
			}
		};

		await Promise.all(
			files.map(async (file) => {
				const uid = uuidv4();
				const res = await upload(`convert/${uid}_${file.name}`, file);
				const payload = {
					fileUrl: res.url,
					fileName: file.name,
					uid,
					specUID: mode === "newSpec" ? specUID : undefined,
				};
				!specUID && delete payload.specUID;
				filesArray.push(payload);
			}),
		).then(async () => {
			await postUploadQuestion(filesArray, params()).then((response) => {
				const { isSuccess, message } = response;
				if (isSuccess) {
					openNotificationWithIcon("success", "上傳成功");
				} else {
					openNotificationWithIcon("error", message);
				}
			});
		});
		setUploadPopup(false);
		setFiles([]);
		sendGetSeparateRecord(FetchEventType.Fetch);
		setIsLoading(false);
	};

	const deleteHandle = (item) => {
		sendGetSeparateRecord(FetchEventType.Delete, {
			fileUID: item.uid,
		});
		setCheckedList([]);
	};

	const handlerDownloadUrl = (fileName, fileUrl) => {
		const link = document.createElement("a");
		link.href = fileUrl;
		// link.target = "_blank";
		link.download = fileName;
		link.click();
	};

	const doConvertQueue = async (payload, params) => {
		const { isSuccess, message } = await convertQueueEdit(payload, params);
		if (!isSuccess) openNotificationWithIcon("error", message);
	};

	const onDetailPageChange = (currentPage) => {
		setDetailPage(currentPage);
	};

	const goTop = () => {
		const scroll = document.querySelector(".ScheduleListTable > .body");
		scroll.scrollTop = 0;
	};

	const pageChange = (currentPage, pageSize) => {
		setPageState({
			...pageState,
			currentPage,
			limit: pageSize,
		});
		goTop();
	};

	const onSelectBookTag = (path) => {
		const isListen = targetSelectOptions.find((item) => item.value === path).isListen;
		setBookTagPath(path);
		setBookTagIsListen(isListen);
	};

	useEffect(() => {
		sendGetSeparateRecord(FetchEventType.Fetch);
		sendGetQuerySeparateRecordSelection(FetchEventType.Fetch);
		sendProductDetail(FetchEventType.Fetch);
	}, [productType]);

	const fetchRecords = () => {
		sendGetSeparateRecord(FetchEventType.Fetch);
	};

	useEffect(() => {
		if (targetSelectOptions.length === 0) return;
		setBookTagPath(targetSelectOptions[0].value);
	}, [targetSelectOptions]);

	//  ========================  修改試題相關  ========================

	const [mode, setMode] = useState("newSpec"); // newSpec - 新規格, oldSpec - 同舊規格。
	const [specUID, setSpecUID] = useState(null);
	const [specParams, setSpecParams] = useState({
		year: getSchoolYear() + "",
		edu: "",
		subject: "",
		version: "",
	});

	const [stateProductDetail, sendProductDetail] = useMachine(fetchMachine, {
		services: {
			fetchData: async () => {
				const result = await getSpecificationProductFilter(specParams.year);
				const selection = result?.data?.selection || {};
				const specList = result?.data?.specList || [];
				return {
					yearMap: setSelectOptions(selection?.yearMap) || [],
					eduMap: setSelectOptions(selection?.eduMap) || [],
					subjectMap: selection?.subjectMap || [],
					versionMap: selection?.versionMap || [],
					specList,
				};
			},
		},
	});

	const { yearMap, eduMap, subjectMap, versionMap, specList } = stateProductDetail.context.result || {};

	const subjectOptions = useMemo(() => {
		if (!subjectMap || !specParams.edu) return [];
		return setSelectOptions(subjectMap[specParams.edu]);
	}, [specParams.edu]);

	const versionOptions = useMemo(() => {
		if (!versionMap || !specParams.edu) return [];
		return setSelectOptions(versionMap[specParams.edu]);
	}, [specParams.edu]);

	const filterSpecList = useMemo(() => {
		const { year, edu, subject, version } = specParams;
		if (!(year || edu || subject || version) || !specList) return [];
		return setSelectOptions(
			specList
				.filter((item) => item.eduSubject === `${edu}${subject}` && item.year === year && item.version === version)
				.map((item) => ({ name: item.name, code: item.uid })),
		);
	}, [specParams, specList]);

	const onSpecParamsChange = (type, value) => {
		if (type === "year") {
			setSpecParams({
				...specParams,
				[type]: value,
				edu: "",
				subject: "",
				version: "",
			});
		} else if (type === "edu") {
			setSpecParams({
				...specParams,
				[type]: value,
				subject: "",
				version: "",
			});
		} else {
			setSpecParams({
				...specParams,
				[type]: value,
			});
		}
		setSpecUID(null);
	};

	useEffect(() => {
		if (!specParams.year) return;
		sendProductDetail(FetchEventType.Fetch);
	}, [specParams.year]);

	const toggleUploadPopupVisible = (type) => {
		type !== "" && setMode(type);
		setUploadPopup(!uploadPopup);
		setFiles([]);
	};

	const lockRuleSelection = useMemo(() => {
		return Object.keys(urlParams).length > 0;
	}, [urlParams]);

	const subjectOption = useMemo(() => {
		if (!selectionData?.eduSubject | !searchParams?.edu) return [];
		return setSelectOptions(selectionData.eduSubject[searchParams.edu]);
	}, [selectionData.eduSubject, searchParams.edu]);

	const versionOption = useMemo(() => {
		if (!selectionData?.eduVersion | !searchParams?.edu) return [];
		return setSelectOptions(selectionData.eduVersion[searchParams.edu]);
	}, [selectionData.eduVersion, searchParams.edu]);

	const changeSearchParams = (key, value) => {
		if (key === "edu") {
			setSearchParams({
				...searchParams,
				[key]: value,
				subject: null,
				version: null,
			});
		} else {
			setSearchParams({
				...searchParams,
				[key]: value,
			});
		}
	};

	const handleDateChange = (e) => {
		if (!e) return;
		setSearchParams({
			...searchParams,
			startDateTime: new Date(e[0]._d),
			EndDateTime: getEndDay(new Date(e[1]._d)),
		});
	};

	const queueDeleteFile = async () => {
		setIsLoading(true);
		const canDelFile = checkList.filter((item) => item.message === "拆解完成");
		const array = canDelFile.map((item) => {
			return item?.uid;
		});
		await putDeleteFile(array).then((res) => {
			const { isSuccess, message } = res;
			if (isSuccess) {
				openNotificationWithIcon("success", "批次刪除完成");
				setPageState({ ...pageState, currentPage: 1 });
			} else {
				openNotificationWithIcon("error", message);
			}
			setIsLoading(false);
			fetchRecords(true);
		});
	};

	const isCheckAll = useMemo(() => {
		if (!records) return false;
		if (checkList.length === records.length && records.length !== 0) return true;
		return false;
	}, [checkList, records]);

	const checkListAll = (e) => {
		const checked = e.target.checked;
		if (checked) {
			setCheckedList([...records]);
		} else {
			setCheckedList([]);
		}
	};

	const IsChecked = (item) => {
		if (checkList.length === 0) return false;
		return checkList.some((data) => data.uid === item.uid);
	};

	const checkHandler = (e, item) => {
		const checked = e.target.checked;

		let nextData = [...checkList];
		if (checked) {
			if (nextData.some((data) => data.uid === item.uid)) return;
			nextData = [...nextData, item];
			setCheckedList([...nextData]);
		} else {
			const dataIndex = nextData.findIndex((data) => data.uid === item.uid);
			nextData.splice(dataIndex, 1);
			setCheckedList([...nextData]);
		}
	};

	const onConfirmHandle = (item) => {
		deleteHandle(item);
		setDeletePopupState(false);
	};

	// 編輯 是否已完成作業
	const doEditCheck = async (fileUID, isChecked) => {
		const { isSuccess, message } = await putEditCheck(fileUID, isChecked);
		if (isSuccess) {
			fetchRecords();
		} else {
			openNotificationWithIcon("error", message);
		}
	};

	const checkWorkDoneHandler = (e, item) => {
		const checked = e.target.checked;
		doEditCheck(item?.uid, checked);
	};

	// 取得 試題列表
	const [, sendGetQuestionList] = useMachine(fetchMachine, {
		services: {
			fetchData: async (_c, event) => {
				setIsLoading(true);
				const { data, isSuccess, message } = await getQuestionList(event.fileUID);
				if (isSuccess) {
					setIsLoading(false);
					setDetailModalData({
						data: data,
						fileUID: event.fileUID,
					});
				}
				return {
					isSuccess,
					message,
				};
			},
		},
	});

	const onDetailPopupHandle = (item) => {
		sendGetQuestionList(FetchEventType.Fetch, {
			fileUID: item?.uid,
		});
		setDetailModalToggle();
		setDetailListPage({
			currentPage: 1,
			limit: 100,
		});
		setFileUID(item?.uid);
		setSpecUID(item?.specUID);
	};

	/* ------------------- 試題詳情列表頁 ------------------- */
	const [fileName, setFileName] = useState("");

	const closeDetailModal = () => {
		setDetailModalFalse();
		setSpecUID(null);
	};

	const isCanDownload_zip = (array) => {
		if (!array | (array.length === 0)) return false;
		const filterArray = array.filter((record) => {
			return record?.message !== "入庫完成";
		});
		return filterArray.length !== 0;
	};

	// 取得 下載 url 相關
	const [, sendGetErrorExportFile] = useMachine(fetchMachine, {
		services: {
			fetchData: async (_c, event) => {
				setIsLoading(true);
				const { data, isSuccess, message } = await getErrorExportFile(event.fileUID);
				const { downloadUrl } = data;

				if (isSuccess) {
					setIsLoading(false);
					const link = document.createElement("a");
					link.href = downloadUrl;
					// link.target = "_blank";
					link.download = fileName;
					link.click();
				} else {
					openNotificationWithIcon("error", message);
				}

				return {
					downloadUrl,
					isSuccess,
					message,
				};
			},
		},
	});

	const getFileUrl = () => {
		if (!fileUID) return null;
		sendGetErrorExportFile(FetchEventType.Fetch, {
			fileUID: fileUID,
		});
	};

	const doDeleteQueue = async (item) => {
		const { isSuccess, message } = await deleteRecordFile(item?.uid);
		if (isSuccess) {
			openNotificationWithIcon("success", "刪除成功");
			sendGetQuestionList(FetchEventType.Fetch, {
				fileUID: detailModalData?.fileUID,
			});
		} else {
			openNotificationWithIcon("error", message);
		}
	};

	const onConfirmHandle_ques = (item) => {
		doDeleteQueue(item);
		setDeletePopupState(false);
	};

	const toggleEditPopupVisible = () => {
		setMode("edit");
		setUploadPopup(!uploadPopup);
		setUrlParams({});
		setFiles([]);
	};

	const reUploadQues = async (item) => {
		const { uid, itemUID, fileUID, fileUrl, fileName, fileUrl2, fileName2, specUID, cms, queS_TYPE } = item;

		const payload = {
			uid,
			itemUID: itemUID ?? "",
			fileUID,
			fileUrl,
			fileName,
			fileUrl2,
			fileName2,
			specUID,
			cms: cms ?? "",
			queS_TYPE,
		};

		const params = {
			queueType: API_BATCH_QUEUE.QUEUE_TYPE.create,
		};
		const { isSuccess, message } = await postReSeparateRecord(payload, params);
		if (isSuccess) {
			sendGetQuestionList(FetchEventType.Fetch, {
				fileUID: detailModalData?.fileUID,
			});
			openNotificationWithIcon("success", "成功重新轉檔");
		} else {
			openNotificationWithIcon("error", message);
		}
	};

	const detailPageChange = (currentPage, pageSize) => {
		setDetailPage({
			...setDetailListPage,
			currentPage,
			limit: pageSize,
		});
	};

	/* ------------------- 單一題目詳情 ------------------- */
	const [detailEduSubject, setDetailEduSubject] = useState("");

	useEffect(() => {
		if (targetDetail && JSON.stringify(targetDetail) !== "{}") {
			sendGetQuestionHtml(FetchEventType.Fetch, {
				eduSubject: detailEduSubject,
				uid: targetDetail.uid,
			});
		}
	}, [targetDetail]);

	const [stateGetQuestionHtml, sendGetQuestionHtml] = useMachine(fetchMachine, {
		services: {
			fetchData: async (_c, event) => {
				const { data, isSuccess, message } = await getQuestionHtml(event.eduSubject, event.uid);
				return {
					questionHtml: data,
					isSuccess,
					message,
				};
			},
		},
	});

	const { questionHtml } = stateGetQuestionHtml.context.result || {};

	return (
		<>
			<UiQuestionRevisePage id="QuestionRevisePage">
				<div className="titleControlBox">
					<div className="flexStartBox">
						<Breadcrumb data={breadcrumbList} />
					</div>
					<div className="searchToolBar">
						<div className="flexStartBox">
							<Select
								placeholder="請選擇轉檔狀態"
								options={filterTypeOptions}
								value={searchParams?.failType}
								onChange={(val) => {
									changeSearchParams("failType", val);
								}}
								allowClear={false}
							/>
							<Select
								placeholder="請選擇作業狀態"
								options={finishedStatusOptions}
								value={searchParams?.isChecked}
								onChange={(val) => {
									changeSearchParams("isChecked", val);
								}}
								allowClear={false}
							/>
						</div>

						<div className="flexEndBox">
							<Button.IconButton variant="red" full={false} iconName="delete_forever" onClick={queueDeleteFile}>
								批次刪除檔案
							</Button.IconButton>
							<Button.IconButton
								variant="green"
								full={false}
								iconName="cloud_upload"
								onClick={() => toggleUploadPopupVisible("newSpec")}>
								新規格-上傳修題
							</Button.IconButton>
							<Button.IconButton
								variant="blue"
								full={false}
								iconName="cloud_upload"
								onClick={() => toggleUploadPopupVisible("oldSpec")}>
								舊規格-上傳修題
							</Button.IconButton>
						</div>
					</div>

					<div className="selectionBar">
						<Select
							placeholder="請選擇學年度"
							options={setSelectOptions(selectionData?.yearMap)}
							value={searchParams.year}
							onChange={(val) => {
								changeSearchParams("year", val);
							}}
							allowClear={false}
						/>
						<Select
							placeholder="請選擇學制"
							options={setSelectOptions(selectionData?.eduMap)}
							value={searchParams.edu}
							onChange={(val) => {
								changeSearchParams("edu", val);
							}}
						/>
						<Select
							placeholder="請選擇科目"
							options={subjectOption}
							disabled={!searchParams?.edu}
							value={searchParams.subject}
							onChange={(val) => {
								changeSearchParams("subject", val);
							}}
						/>
						<Select
							placeholder="請選擇版本"
							options={versionOption}
							disabled={!searchParams?.edu}
							value={searchParams.version}
							onChange={(val) => {
								changeSearchParams("version", val);
							}}
						/>
						<Select
							placeholder="請選擇冊次"
							options={setSelectOptions(selectionData?.bookMap)}
							value={searchParams.book}
							onChange={(val) => {
								changeSearchParams("book", val);
							}}
						/>
						<Select
							placeholder="請選擇出處"
							options={setSelectOptions(selectionData?.sourceMap)}
							value={searchParams.source}
							onChange={(val) => {
								changeSearchParams("source", val);
							}}
						/>
						<Select
							placeholder="請選擇來源"
							options={setSelectOptions(selectionData?.subSourceMap)}
							value={searchParams.subSource}
							onChange={(val) => {
								changeSearchParams("subSource", val);
							}}
						/>
					</div>
					<div className="dateFilterBox">
						<RangePicker
							value={[moment(searchParams?.startDateTime, dateFormat), moment(searchParams?.EndDateTime, dateFormat)]}
							onChange={handleDateChange}
							allowClear={false}
						/>
					</div>

					<div className="searchBox">
						<div className="searchInputBox">
							<label>檔案名稱：</label>
							<input
								type="text"
								placeholder="請輸入檔案名稱"
								onChange={(e) => changeSearchParams("fileName", e.target.value)}
							/>
						</div>

						<div className="searchInputBox">
							<label>上傳者名稱：</label>
							<input
								type="text"
								placeholder="請輸入上傳者名稱"
								onChange={(e) => changeSearchParams("userName", e.target.value)}
							/>
						</div>

						<Button variant="orange" onClick={fetchRecords}>
							搜尋
						</Button>

						<Button variant="green" onClick={fetchRecords}>
							重新整理
						</Button>

						<div className="exportButtonBox">
							<Button
								variant="green"
								onClick={handleBatchExport}
								loading={stateBatchExport.matches(FetchStates.Loading)}>
								匯出
							</Button>
						</div>
					</div>
				</div>

				<Table margin="3" className={"ScheduleListTable"}>
					<Header className={"header"}>
						<Row>
							<Item className="checkboxItem" flex="0.1">
								<Checkbox
									indeterminate={checkList.length !== 0 && !isCheckAll}
									checked={isCheckAll}
									onChange={(event) => {
										checkListAll(event);
									}}
								/>
							</Item>
							<Item flex="1.5">檔案名稱</Item>
							<Item flex="0.75">檔案狀態</Item>
							<Item flex="1">日期</Item>
							<Item flex="1">規格名稱</Item>
							<Item flex="1">上傳者</Item>
							<Item flex="2.75">操作</Item>
							<Item flex="0.75">完成作業</Item>
						</Row>
					</Header>
					<Body className={"body"}>
						{records &&
							records.map((item, index) => {
								return (
									<Row key={index}>
										<Item className="checkboxItem" flex="0.1">
											<Checkbox
												checked={IsChecked(item)}
												onChange={(event) => {
													checkHandler(event, item);
												}}
												disabled={item.message !== "拆解完成"}
											/>
										</Item>
										<Item flex="1.5">{item?.fileName}</Item>
										<Item flex="0.75">{item?.message}</Item>
										<Item flex="1">{format(getTime(new Date(item?.systemTime)), "yyyy-MM-dd HH:mm")}</Item>
										<Item flex="1">
											{item?.specName ? (
												<UiLink
													className="link"
													onClick={() => {
														history.push(`/ruleSearchDetail/${item?.specUID}`);
													}}>
													{item.specName}
												</UiLink>
											) : (
												""
											)}
										</Item>
										<Item flex="1">{item?.userName}</Item>
										<Item flex="2.75" className="controlBox">
											<Button.IconButton
												variant={item?.message !== "拆解完成" ? "ui01" : "orange"}
												disabled={item?.message !== "拆解完成"}
												full={false}
												iconName="visibility"
												onClick={() => onDetailPopupHandle(item)}>
												看更多
											</Button.IconButton>

											<Button.IconButton
												disabled={!item?.fileUrl}
												variant={item?.fileUrl ? "blue" : "ui01"}
												full={false}
												iconName="save_alt"
												onClick={() => handlerDownloadUrl(item?.fileName, item?.fileUrl)}>
												下載
											</Button.IconButton>

											<Button.Popconfirm
												variant={item?.uid ? "red" : "ui01"}
												disabled={!item?.uid}
												title="確定要刪除嗎?"
												block={false}
												full={false}
												onCancel={() => setDeletePopupState(false)}
												onConfirm={() => onConfirmHandle(item)}
												onClick={() => setDeletePopupState(true)}
												visible={deletePopupState}>
												<Icon name="delete_forever" mr="2" />
												刪除
											</Button.Popconfirm>
										</Item>
										<Item flex="0.75">
											<Checkbox
												checked={item?.isChecked}
												onChange={(event) => {
													checkWorkDoneHandler(event, item);
												}}
											/>
										</Item>
									</Row>
								);
							})}
					</Body>
				</Table>
				<Pagination
					total={totalCount || 0}
					defaultCurrent={1}
					current={pageState.currentPage}
					onChange={pageChange}
					defaultPageSize={pageState.limit}
				/>

				{/* ------------------- 試題詳情列表頁 ------------------- */}

				<StyledModal
					visible={detailModalVisible}
					zIndex={1001}
					onCancel={closeDetailModal}
					id={"detailModal"}
					title={"試題列表"}
					footer={
						detailModalData?.data && (
							<>
								<Button.IconButton variant="blue" full={false} iconName="cloud_upload" onClick={toggleEditPopupVisible}>
									上傳修題
								</Button.IconButton>
								<Button
									variant={isCanDownload_zip(detailModalData?.data) ? "blue" : "ui02"}
									disabled={!isCanDownload_zip(detailModalData?.data)}
									onClick={() => getFileUrl(detailModalData?.data)}>
									下載所有錯誤題目
								</Button>
							</>
						)
					}>
					<Table margin="3" className={"questionListTable"}>
						<Header>
							<Row>
								<Item flex="2">檔案名稱</Item>
								<Item flex="2">題目UID</Item>
								<Item flex="1">檔案狀態</Item>
								<Item flex="1.25">日期</Item>
								<Item flex="2">操作</Item>
							</Row>
						</Header>
						<Body>
							{detailModalData?.data &&
								sliceTableData(detailModalData?.data, detailPageListState.currentPage, detailPageListState.limit).map(
									(item, index) => {
										return (
											<Row key={index}>
												<Item flex="2">{item?.fileName}</Item>
												<Item flex="2">{item?.itemUID}</Item>
												<Item flex="1">{item?.message}</Item>
												<Item flex="1.25">{format(getTime(new Date(item?.systemTime)), "yyyy-MM-dd HH:mm")}</Item>
												<Item flex="2" className={"controlBox"}>
													<Button.IconButton
														variant={item?.message !== "入庫完成" ? "ui01" : "orange"}
														disabled={item?.message !== "入庫完成"}
														full={false}
														iconName="visibility"
														onClick={() => toggleDetailVisible(item)}>
														題目詳情
													</Button.IconButton>

													<Button.IconButton
														disabled={!item?.failedUrl && !item?.fileUrl}
														variant={item?.failedUrl || item?.fileUrl ? "blue" : "ui01"}
														full={false}
														iconName="save_alt"
														onClick={() => {
															handlerDownloadUrl(item?.downloadName, item?.failedUrl || item?.fileUrl);
														}}>
														下載
													</Button.IconButton>

													<Button.Popconfirm
														variant={"red"}
														title="確定要刪除嗎?"
														block={false}
														full={false}
														onCancel={() => setDeletePopupState(false)}
														onConfirm={() => onConfirmHandle_ques(item)}
														onClick={() => setDeletePopupState(true)}
														visible={deletePopupState}>
														<Icon name="delete_forever" mr="2" />
														刪除
													</Button.Popconfirm>

													<Button.IconButton
														variant={item?.isCMSFinished ? "ui01" : "green"}
														full={false}
														iconName="restart_alt"
														type="outLined"
														// loading={reSubmitLoading}
														disabled={item?.isCMSFinished}
														onClick={async () => {
															await reUploadQues(item);
														}}>
														重新轉檔
													</Button.IconButton>
												</Item>
											</Row>
										);
									},
								)}
						</Body>
					</Table>
					<Pagination
						total={detailModalData?.data?.length || 0}
						defaultCurrent={1}
						current={detailPageListState.currentPage}
						onChange={detailPageChange}
						defaultPageSize={detailPageListState.limit}
					/>
				</StyledModal>

				{/* ------------------- 單一題目詳情 ------------------- */}

				<UiQuesDetail
					visible={detailPopup.visible}
					onCancel={toggleDetailVisible}
					getContainer={document.getElementById("QuestionRevisePage")}
					width="75%"
					zIndex={1010}
					id={"quesDetail"}
					footer={
						<Pagination
							textcolor="#000"
							total={detailList?.length || 0}
							defaultPageSize={1}
							variant="white"
							current={detailPage}
							onChange={onDetailPageChange}
						/>
					}>
					<UiPopupContainer id="quesTab">
						<Tabs
							defaultActiveKey="1"
							tabBarExtraContent={
								<>
									{targetDetail?.questionPdf ? (
										<Button.IconButton
											variant="blue"
											type="outLined"
											iconName="picture_as_pdf"
											onClick={() => {
												window.open(targetDetail.questionPdf, "_blank");
											}}>
											PDF
										</Button.IconButton>
									) : (
										""
									)}
								</>
							}>
							<Tabs.TabPane tab={"線上測驗解析結果"} key="1">
								{questionHtml && <FileCheck key={questionHtml} questionHtml={questionHtml}></FileCheck>}
							</Tabs.TabPane>

							<Tabs.TabPane
								tab={
									<>
										<Icon name="widgets" />
										解析狀態
									</>
								}
								key="2">
								<div className="container">
									<div className="content">
										<div className="title">題目</div>
										<div className="bookTag">
											<Select
												label="解析書籤名稱:"
												options={targetSelectOptions}
												value={bookTagPath}
												onChange={(val) => {
													onSelectBookTag(val);
												}}
											/>
										</div>
										<div className="img">
											{bookTagIsListen ? (
												<audio controls src={bookTagPath || "error"}>
													Your browser does not support the
													<code>audio</code> element.
												</audio>
											) : (
												<Image
													src={bookTagPath || "error"}
													preview={{
														getContainer: document.getElementById("quesTab"),
													}}
													fallback="data:image/png;base64,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"
												/>
											)}
										</div>
									</div>
									<div className="content">
										<div className="title">基本資料</div>
										<div className="meta">
											編號:
											<span className="metaContent">{targetDetail?.uid}</span>
										</div>
										{targetDetail?.metadata &&
											targetDetail.metadata.map((meta, index) => {
												return (
													<div className="meta" key={index}>
														{`${meta.name}: `}
														{meta.content.map((content, contentIndex) => {
															return (
																<span className="metaContent" key={contentIndex}>
																	{new Set(showCodeList).has(meta.code) ? content.code : content.name}
																</span>
															);
														})}
													</div>
												);
											})}
									</div>
								</div>
							</Tabs.TabPane>

							<Tabs.TabPane
								tab={
									<>
										<Icon name="visibility" />
										檢視更多
									</>
								}
								key="3">
								<div className="container">
									<div className="content">
										<div className="title">題目</div>
										<div className="img">
											<Image
												src={targetDetail?.questionImage || "error"}
												preview={{
													getContainer: document.getElementById("quesTab"),
												}}
												fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
											/>
										</div>
										<ul className="info">
											<li>
												入庫時間:{" "}
												{targetDetail?.createTime && format(new Date(targetDetail.createTime), "yyyy-MM-dd HH:mm")}
											</li>
											<li>最後修改時間: {targetDetail?.updateTime}</li>
										</ul>
									</div>
									<div className="content">
										<div className="title">基本資料</div>
										<div className="meta">
											編號:
											<span className="metaContent">{targetDetail?.uid}</span>
										</div>
										{targetDetail?.metadata &&
											targetDetail.metadata.map((meta, index) => {
												return (
													<div className="meta" key={index}>
														{`${meta.name}: `}
														{meta.content.map((content, contentIndex) => {
															return (
																<span className="metaContent" key={contentIndex}>
																	{new Set(showCodeList).has(meta.code) ? content.code : content.name}
																</span>
															);
														})}
													</div>
												);
											})}
									</div>
								</div>
							</Tabs.TabPane>
						</Tabs>
					</UiPopupContainer>
				</UiQuesDetail>

				{/* ------------------- 新舊規格上傳修題 ------------------- */}

				<Modal
					width={600}
					visible={uploadPopup}
					onCancel={() => toggleUploadPopupVisible("")}
					onOk={submitFiles}
					title="上傳修題"
					footer={
						<UiButtons>
							<Button
								variant="white"
								full={false}
								onClick={() => toggleUploadPopupVisible("")}
								Key="cancel"
								loading={isLoading}>
								取消
							</Button>
							<Button
								variant="orange"
								full={false}
								onClick={submitFiles}
								Key="ok"
								loading={isLoading}
								disabled={files.length === 0}>
								確認
							</Button>
						</UiButtons>
					}>
					{mode === "newSpec" && (
						<UiRuleModalContent>
							<div className="ruleDetail">
								<Select
									value={specParams.year}
									disabled={lockRuleSelection}
									options={yearMap}
									placeholder="請選擇年度*"
									onChange={(val) => {
										onSpecParamsChange("year", val);
									}}
									allowClear={false}
								/>
								<Select
									value={specParams.edu || null}
									disabled={lockRuleSelection}
									options={eduMap}
									placeholder="請選擇學制*"
									onChange={(val) => {
										onSpecParamsChange("edu", val);
									}}
								/>
								<Select
									value={specParams.subject || null}
									disabled={lockRuleSelection}
									options={subjectOptions}
									placeholder="請選擇科目*"
									onChange={(val) => {
										onSpecParamsChange("subject", val);
									}}
								/>
								<Select
									value={specParams.version || null}
									disabled={lockRuleSelection}
									options={versionOptions}
									placeholder="請選擇版本*"
									onChange={(val) => {
										onSpecParamsChange("version", val);
									}}
								/>
							</div>
							<div className="ruleDetail">
								<Select
									value={specUID}
									disabled={lockRuleSelection}
									options={filterSpecList}
									placeholder="請選擇入庫規格*"
									onChange={(val) => {
										setSpecUID(val);
									}}
								/>
							</div>
						</UiRuleModalContent>
					)}
					<Upload
						fileList={files}
						multiple={true}
						onChange={changeFileList}
						prompt={
							<>
								僅限上傳999個Microsoft Word 檔<br />
								(副檔名 : .doc/.docx)
							</>
						}
						acceptFileType=".doc,.docx"
					/>
				</Modal>
				{isLoading && (
					<UiLoadingBox>
						<Loading />
					</UiLoadingBox>
				)}
			</UiQuestionRevisePage>
		</>
	);
};

QuestionRevisePage.propTypes = {};
